














import Vue from 'vue'
import DatePicker from '@/components/TimelineDatePicker.vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import Project from '@/models/Project'

class ChangeUserGroupData
{
	public pid = "";
	public usergroup = 0;
	public newPermissions = 0;
}

class JobData<T>
{
	public id = 0;
	public type = 0;
	public exec_time = "";
	public data! : T;
}

@Component({
	components: {
		DatePicker
	}
})
export default class DueDate extends Vue {
	@Prop() readonly group_editor! : any
	@Prop() readonly project! : Project
	datetime = new Date()
	loading = false;
	jobs : JobData<ChangeUserGroupData>[] = [];

	beforeMount(){
		this.datetime.setHours(23);
		this.datetime.setMinutes(59);
		this.$set(this, 'datetime', this.datetime);
	}

	mounted(){
		this.loadDueDates();
	}

	async deleteDueDate()
	{
		await this.loadDueDates();

		this.loading = true;
		try
		{
			for(let i = 0; i < this.jobs.length; ++i) {
				await this.$http.delete(`projects/permissions/delayed?projectid=${this.project.id}&jobid=${this.jobs[i].id}`);
			}
		}
		catch(ex)
		{
			alert(`Error updating due date: ${ex.response.data.error}`);
		}
		this.loading = false;
		await this.loadDueDates();
		this.$forceUpdate();
		this.$emit('refresh')
	}

	async setDueDate(){
		// Clear old due dates
		if (this.jobs.length > 0)
		{
			await this.deleteDueDate();
		}

		this.loading = true;
		try
		{
			let form = new FormData();
			form.append('projectid', this.project.id);
			form.append('time', this.datetime.toUTCString());
			form.append('group', this.group_editor.active_group.id);
			form.append('permissions', (1).toString());
			await this.$http.post(`projects/permissions/delayed`, form);
		}
		catch(ex)
		{
			alert(`Error updating due date: ${ex.response.data.error}`);
		}
		
		this.loading = false;
		await this.loadDueDates();
		this.$forceUpdate();
		this.$emit('refresh')
	}

	async loadDueDates(){
		this.jobs.length = 0;
		this.loading = true;
		try
		{
			let resp = await this.$http.get(`projects/permissions/delayed?projectid=${this.project.id}`);
			this.$set(this, 'jobs', resp.data.jobs as JobData<ChangeUserGroupData>[]);
			if (this.jobs.length > 0)
			{
				let job = this.jobs[0];
				let date = new Date(job.exec_time + 'Z');
				//let date = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
				console.log(date);
				this.$set(this, 'datetime', date);
			}
			this.$emit('request-enable', true);
		}
		catch(ex)
		{
			console.log(`Error loading due date: ${ex.response.data.error}`);
			this.$emit('request-enable', false);
		}
		this.loading = false;
	}
}
